import { render, staticRenderFns } from "./GoodNeedsItem.vue?vue&type=template&id=541f9eca&scoped=true&"
import script from "./GoodNeedsItem.vue?vue&type=script&lang=js&"
export * from "./GoodNeedsItem.vue?vue&type=script&lang=js&"
import style0 from "./GoodNeedsItem.vue?vue&type=style&index=0&id=541f9eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541f9eca",
  null
  
)

export default component.exports